export enum CollectionItemType {
  Undefined = "UNDEFINED",
  EitherOr = "EITHER_OR",
  MultipleChoice = "MULTIPLE_CHOICE",
  MultipleResponse = "MULTIPLE_RESPONSE",
  ShortAnswer = "SHORT_ANSWER",
  Essay = "ESSAY",
  Numeric = "NUMERIC",
  Match = "MATCH",
  Order = "ORDER",
  Hotspot = "HOTSPOT",
  FileResponse = "FILE_RESPONSE",
  FillInTheBlankText = "FILL_IN_THE_BLANK_TEXT",
  FillInTheBlankGap = "FILL_IN_THE_BLANK_GAP",     /* Not use it. Maybe future question. Drag and drop. */
  Equation = "EQUATION",
  SelectFromTheList = "SELECT_FROM_THE_LIST",
  Sowiso = "SOWISO",
  Section = "SECTION",
  AssessmentPage = "ASSESSMENT_PAGE",
  ExtendedMatch = "EXTENDED_MATCH",
  DragAndDrop = "DRAG_AND_DROP",
  Programming = "PROGRAMMING",
  FinancialStatement = "FINANCIAL_STATEMENTS",
  ExtendedMultipleChoice = "EXTENDED_MULTIPLE_CHOICE",
  ComprehensiveIntegratedPuzzle = "COMPREHENSIVE_INTEGRATED_PUZZLE",
}
